import { NoStyleButton } from "@fullscript/aviary-web";
import { Trans } from "react-i18next";

import { l } from "@shared/locales/i18n";

import { noStyleButton } from "./SuggestedEmail.styles";

interface Props {
  suggestedEmail: string;
  handleSuggestedEmailClick: () => void;
}

const SuggestedEmail = ({ suggestedEmail, handleSuggestedEmailClick }: Props) => {
  return (
    <Trans values={{ suggestedEmail }} i18nKey={l.sharedCommon.DidYouMeanThisEmail}>
      Did you mean
      <NoStyleButton
        aria-label={l.sharedCommon.SelectSuggestedEmail}
        customCss={noStyleButton}
        onClick={handleSuggestedEmailClick}
      >
        {suggestedEmail}
      </NoStyleButton>
      ?
    </Trans>
  );
};

export { SuggestedEmail };
